var flickity = require('flickity'),
    formValidation = require('formValidation'),
    loader = require('loader'),
    wordCount = require('wordCount');

var createTeam = (function() {

    var $slider = $('.flickity-carousel-outer');
    var $form = $('#create-a-team');

    var formValidation = function() {
        $form.validate({
            ignore: ":hidden",
            onsubmit: true,
            rules: {
                team_name: {
                    required: true
                },
                team_bio: {
                    maxlength: 3000
                },
            },
            submitHandler: function() {

            }
        });
    };


    var createTeamBtn = function() {
        $('body').on('click', '#create-team-button', function(e) {
            e.preventDefault();
            if($form.valid() === true) {
                $('window').showLoader();
                getValues();
            } else {
                $form.valid();
            }
        });
    };

    var getValues = function(){
        var item = {};

        item.clubId = $('#team_name').attr('data-club-id');
        item.teamName = $('#team_name').val();
        item.teamAgeGroup = $('#team_age_group').val();
        item.teamBio = $('#team_bio').val();
        item.teamLeague = $('#team_league').val();
        item.teamAddressType = $('#team_address_type').val();
        item.teamAddressLine1 = $('#team_address_line1').val();
        item.teamAddressLine2 = $('#team_address_line2').val();
        item.teamAddressCity = $('#team_address_city').val();
        item.teamAddressPostcode = $('#team_address_postcode').val();

        var data = JSON.stringify(item);
        createTeamService(data, successFn);
    };


    var successFn = function(response) {
        var url = null;
        if(response.statusCode === 200) {
            $('window').notification({
                title: response.message
            });
            url = '/team/' + response.data.id;
            window.location.href = url;
        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };


    var errorFn = function(response) {
        $('window').notification({
            title: 'Error 500 - cannot communicate with server',
            error: true
        });
    };


    var init = function() {
        formValidation();
        createTeamBtn();
        var elem = $("#counter");
        $("#team_bio").limiter(3000, elem);
    };

    return {
        init: init
    };

})();


if($('#create-a-team').length) {
    createTeam.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/create-team.js